const doc = [({"da":({"js":({"admin":({"show_boxes":({"partial":({"attribute":({"the_attribute_was_deleted":"Attributten blev slettet."})})})})})})})];
module.exports = doc.length <= 1 ? doc[0] : doc;